import gql from 'graphql-tag'
import fragment from './fragment'

export default gql`
mutation updateCashBookSettings($id: ID!, $fields: CashBookSettingsInput) {
	cashAssist {
		updateCashBookSettings(id: $id, fields: $fields) {
			id
			...CashBookSettingsMain
		}
	}
}
${fragment}`
